import Swiper from "swiper";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";

// Import Swiper core and module styles explicitly
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/pagination";
// @ts-ignore
import "swiper/css/navigation";
// @ts-ignore
import "swiper/css/effect-fade";

document.querySelectorAll(".logo-list-swiper").forEach((el) => {
    new Swiper(el as HTMLElement, {
        modules: [Autoplay],
        loop: true,
        autoplay: {
            delay: 2000,
            pauseOnMouseEnter: true,
        },
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        spaceBetween: 32,
    });
});

document.querySelectorAll(".testimonial-swiper").forEach((el) => {
    const slideCount = el.querySelectorAll(".swiper-slide").length;
    new Swiper(el as HTMLElement, {
        modules: [Pagination, Autoplay, Navigation],
        autoplay: {
            delay: 8000,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: el.querySelector(".next-page-swiper") as HTMLElement,
            prevEl: el.querySelector(".prev-page-swiper") as HTMLElement,
            disabledClass: "disabled",
        },
        pagination: {
            el: el.querySelector(".swiper-pagination") as HTMLElement,
            clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 32,
        loop: slideCount > 1,
        watchOverflow: true,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        centeredSlides: slideCount < 2,
        breakpoints: {
            640: {
                loop: slideCount > 2,
                slidesPerView: 2,
                centeredSlides: slideCount > 2,
            },
            1024: {
                loop: slideCount > 3,
                slidesPerView: Math.min(slideCount, 3),
                centeredSlides: slideCount > 3,
            },
        },
    });
});

document.querySelectorAll(".benefit-swiper").forEach((el) => {
    new Swiper(el as HTMLElement, {
        modules: [Autoplay, EffectFade],
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        speed: 600,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 0,
    });
});

document.querySelectorAll(".job-preview-swiper").forEach((el) => {
    const parent = el.parentElement;
    new Swiper(el as HTMLElement, {
        modules: [Navigation, Pagination],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 32,
        navigation: {
            nextEl: ".next-page-swiper",
            prevEl: ".prev-page-swiper",
            disabledClass: "disabled",
        },
        centerInsufficientSlides: true,
        pagination: {
            el: parent?.querySelector(".swiper-pagination-fraction") as HTMLElement,
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
                return (
                    '<span class="' + currentClass + '"></span>' + " von " + '<span class="' + totalClass + '"></span>'
                );
            },
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });
});
